import nonVSSpacesBase from "./nonVSSpacesBase";
import { SpaceConfig } from "./spaceConfig";
import { SpaceId } from "./spaceIds";
import { UnknownSlugWorkaround } from "./spacesBase";

const spaceTfs: SpaceConfig = {
    ...nonVSSpacesBase,
    id: SpaceId.Tfs,
    displayName: "Azure DevOps Server (TFS)",
    slug: UnknownSlugWorkaround,
    spaceTag: { type: "tag", value: "azure-devops-server" },
    reportProblemConfig: {
        ...nonVSSpacesBase.reportProblemConfig,
    },
    reportSuggestionConfig: {
        ...nonVSSpacesBase.reportSuggestionConfig,
    },
    accentColor: "#0078d4", // Azure blue
};

export default spaceTfs;
